import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addMetaKey({ commit }, item) {
    return this.$axios.$post('admin/metaKeys/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeMetaKey({ commit }, item) {
    return this.$axios.$delete(`admin/metaKeys/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateMetaKey({ commit }, item) {
    return this.$axios.$put(`admin/metaKeys/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchMetaKey({ commit }, id) {
    return this.$axios.$get(`admin/metaKeys/${id}`).then((response) => {
      return response.data
    })
  },
  fetchMetaKeys({ commit }) {
    return this.$axios.$get('admin/metaKeys').then((response) => {
      commit('load', response.data)
    })
  },
}
